import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { GlobalSearchEnum } from 'app/shared/enums/global-search.enum';
import { GlobalSearchItemModel, GlobalSearchResponseModel } from 'app/shared/models/global-search.model';
import { DataTableSortEnum, DataTableStateModel } from '../dynamic-table/dynamic-table.model';
import { HelperService } from 'app/shared/services/helper.service';

@Injectable({
  providedIn: 'root'
})
export class GlobalSearchDatatableService {

  constructor(private http: HttpClient, private helperService: HelperService) { }

  getElkSearch(gridUrl: string, searchValue: string): Observable<GlobalSearchResponseModel> {
    let mainUrl = '';
    let searchCaseType = '';

    switch (gridUrl) {
      case GlobalSearchEnum.GRID_URL_CASES:
        mainUrl = `elksearch-case`;
        searchCaseType = 'Case';
        break;
      case GlobalSearchEnum.GRID_URL_KNOWLEDGE_LIBRARY:
        mainUrl = `elksearch-case`;
        searchCaseType = 'Knowledge';
        break;
      case GlobalSearchEnum.GRID_URL_PROBLEM_RECORDS:
        mainUrl = `elksearch-problem-record`;
        break;
    }

    let params: any = {
      takeCount: 3,
      isOrderByDescending: true,
      fieldFilters: []
    };

    const url = gridUrl === GlobalSearchEnum.GRID_URL_PROBLEM_RECORDS
      ? `/v1/${mainUrl}/search?querySearch=${searchValue}`
      : `/v1/${mainUrl}/search?querySearch=${searchValue}&searchCaseType=${searchCaseType}`;

    return this.http.post<GlobalSearchResponseModel>(url, params);
  }


  getElkDataTableSearch(gridUrl: string, searchValue: string, data: DataTableStateModel): Observable<any[]> {
    data = this.helperService.replaceFilterBlanksSelection(data);
    
    let searchCaseType = '';

    switch (gridUrl) {
      case GlobalSearchEnum.GRID_URL_CASES:
        searchCaseType = 'Case';
        break;
      case GlobalSearchEnum.GRID_URL_KNOWLEDGE_LIBRARY:
        searchCaseType = 'Knowledge';
        break;
    }

    let params: any = {
      skipCount: data.showItemsPerPage * (data.pageNumber - 1),
      takeCount: data.showItemsPerPage,
      isOrderByDescending: data.sortingValue.dir === DataTableSortEnum.SORT_DESC,
      orderField: data.sortingValue.prop || undefined,
      fieldFilters: data.datatableFilters || []
    };

    let mainUrl = '';

    switch (gridUrl) {
      case GlobalSearchEnum.GRID_URL_CASES:
      case GlobalSearchEnum.GRID_URL_KNOWLEDGE_LIBRARY:
        mainUrl = `/v1/elksearch-case/search?querySearch=${searchValue}&searchCaseType=${searchCaseType}`;
        break;
      case GlobalSearchEnum.GRID_URL_PROBLEM_RECORDS:
        mainUrl = `/v1/elksearch-problem-record/search?querySearch=${searchValue}`;
        break;
    }

    return this.http.post<any[]>(mainUrl, params);
  }

  mapSearchData(gridUrl: string, items: Array<Object>) {
    let data: GlobalSearchItemModel[] = [];
    let propertyFirst = '';
    let propertySecond = '';

    switch (gridUrl) {
      case GlobalSearchEnum.GRID_URL_CASES:
      case GlobalSearchEnum.GRID_URL_KNOWLEDGE_LIBRARY:
        propertyFirst = 'caseTitle';
        propertySecond = 'caseIdentifier';
        break;
      case GlobalSearchEnum.GRID_URL_PROBLEM_RECORDS:
        propertyFirst = 'problemTitle';
        propertySecond = 'problemRecordIdentifier';
        break;
    }

    data = items.map((item: any) => ({
      id: item.id,
      title: item[propertyFirst],
      identifier: item[propertySecond]
    }));

    return data as GlobalSearchItemModel[];
  }
}
